/**
 * @file Swatches are backgrounds used on beam.
 * See {@link https://www.figma.com/file/HuBNej9pXv8gFvq17Zi3zP/Beam-Design-System?node-id=5413%3A4855 Elevation and Cards}  */
import { CSSObject } from '@mantine/core';

//  Elevation
/**
 * Flat panel
 */
export const Elevation0: CSSObject = {
  backgroundColor: '#FFFFFF',
  borderRadius: 4,
};
/**
 * Hover, dialog, tooltip
 */
export const Elevation1: CSSObject = {
  backgroundColor: '#FFFFFF',
  borderRadius: 8,
  boxShadow: '0px 4px 6px rgba(33, 39, 73, 0.06)',
};

/**
 * Toast, dropdown menu
 */
export const Elevation2: CSSObject = {
  backgroundColor: '#FFFFFF',
  borderRadius: 4,
  boxShadow: '0px 6px 10px rgba(33, 39, 73, 0.12)',
};
/**
 * Corner dialog
 */
export const Elevation3: CSSObject = {
  boxShadow: '0px 12px 28px rgba(33, 39, 73, 0.2)',
  borderRadius: 8,
  backgroundColor: '#FFFFFF',
};

/**
 * Actual menu/dialog elevations
 */
export const Elevation1_5: CSSObject = {
  boxShadow: '0 1px 4px rgb(0 0 0 / 16%)',
  borderRadius: 8,
  backgroundColor: '#FFFFFF',
};
